import Button from '@/theme/foundations/components/button';
import Checkbox from '@/theme/foundations/components/checkbox';
import Input from '@/theme/foundations/components/input';
import { modalTheme } from '@/theme/foundations/components/modal';

export default { Button, Input, Checkbox, Modal: modalTheme };
